import {
    GTM_IMPRESSIONS, GTM_ADD_TO_CART, CART_LOAD_ERROR
} from '../constants';


import { get } from '../../../Services/http';
import { catchError } from '../../../Actions/Error.action';
import ClickTrackingDataBuilder from '../ClickTrackingDataBuilder';
import AddToCartTrackingDataBuilder from '../AddToCartTrackingDataBuilder';
import RemoveFromCartTrackingDataBuilder from '../RemoveFromCartTrackingDataBuilder';
import ProductBuilder from '../ProductBuilder';

export const sendGtmImpressions = (displayProductsAmount) => (dispatch, getState) => {
    let gtmImpression = getImpressionData(displayProductsAmount, getState);
    window.gtmTracker.impressions(gtmImpression);
}

export const sendGtmClick = (itemIndex) => (dispatch, getState) => {
    let builder = new ClickTrackingDataBuilder();
    let clickedProduct = getClickedProduct(itemIndex, getState);
    let data = builder.build(clickedProduct);

    window.gtmTracker.click(data);
}

export const productLinkClick = (item, itemIndex) => (dispatch, getState) => {
   
    let builder = new ClickTrackingDataBuilder();
    //let clickedProduct = getClickedProduct(itemIndex, getState);
    item.position = itemIndex + 1;
    let data = builder.build(item);

    window.gtmTracker.click(data);
}

const getClickedProduct = (itemIndex, getState) => {
    let impresssionResult = getState().quickSearch.gtmImpressionResult;
    let clickedProduct = impresssionResult.impressions.products.filter(Boolean).slice(itemIndex, itemIndex + 1);

    return clickedProduct[0];
}

export const updateProductInCart = (orderRowId, quantity, currentQuantity) => (dispatch, getState) => {
    
    let row = getState().cart.orderRows.find(r => {
        return r.rowSystemId == orderRowId;
    });
    let articleNumber = row.articleNumber;
    
    let products = getState().gtmPNCart.products;
    let product = products.find(p => {
        return p.id === articleNumber;
    });

    if (product !== undefined) {
        processUpdate(product, currentQuantity, quantity);
        product.quantity = quantity;
        dispatch(receive(products));
    } else {
        return get(`/api/gtmPNCart/prodDetails/${articleNumber}`)
            .then(response => response.json())
            .then(result => {
                processUpdate(result, currentQuantity, quantity);
                products.push(result);
                dispatch(receive(products));
            })
            .catch(ex => dispatch(catchError(ex, error => loadError(error))));
    }
}

export const removeProductInCart = (product) => (dispatch, getState) => {
    let builder = new ProductBuilder();
    if (product !== undefined) {
        processUpdate(product, product.quantity, 0);
    }
};

export const addProductToCart = (articleNumber, quantity) => (dispatch, getState) => {

    let products = getState().gtmPNCart.products;
    let product = products.find(p => {
        return p.id === articleNumber;
    });

    let builder = new ProductBuilder();

    if (product !== undefined) {
        
        let p = builder.build(product, quantity);
        sendGtmAddToCart(p, window.gtmeecom.currentPageType);

        product.quantity = product.quantity + quantity;
        dispatch(receive(products));
    }
    else {
        return get(`/api/gtmPNCart/prodDetails/${articleNumber}`)
            .then(response => response.json())
            .then(result => {
                let p = builder.build(result, quantity)
                sendGtmAddToCart(p, window.gtmeecom.currentPageType)
                products.push(p)
                dispatch(receive(products))
            })
            .catch(ex => dispatch(catchError(ex, error => loadError(error))));
    }
}

export const loadError = error => ({
    type: CART_LOAD_ERROR,
    payload: {
        error
    }
});

const receive = products => ({
    type: GTM_ADD_TO_CART,
    payload: {
        products: products
    }
});

const processUpdate = (product, currentQuantity, newQuantity) => {
    let builder = new ProductBuilder();
    
    if (newQuantity === 0) {
        
        let p = builder.build(product, currentQuantity);
        sendGtmRemoveFromCart(p);
    }
    else if (newQuantity > currentQuantity) {
        let addedQuantity = newQuantity - currentQuantity;
        let p = builder.build(product, addedQuantity);
        sendGtmAddToCart(p, "Shopping Cart")
    }
    else if (newQuantity < currentQuantity) {
        let removedQuantity = currentQuantity - newQuantity;
        let p = builder.build(product, removedQuantity);
        sendGtmRemoveFromCart(p);
    }
};

const sendGtmAddToCart = (product, actionFieldList) => {
    let builder = new AddToCartTrackingDataBuilder();
    let data = builder.build(product, actionFieldList);
    window.gtmTracker.add(data);
    //window.facebookTracker.trackAdd();
};

const sendGtmRemoveFromCart = (product) => {
    let builder = new RemoveFromCartTrackingDataBuilder();
    let data = builder.build(product);

    window.gtmTracker.remove(data);
};

const getImpressionData = (displayProductsAmount, getState) => {
    let gtmImpression = getState().quickSearch.gtmImpressionResult;
    let displayProducts = gtmImpression.impressions.products.filter(Boolean).slice(0, displayProductsAmount);
    gtmImpression.products = displayProducts;

    return gtmImpression;
}
